module.exports = __webpack_public_path__ + "static/media/mns-video.cef9fd20.m4v";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/mns-video.m4v
// module id = 202
// module chunks = 0